<template>
  <div>
    <iModal title="新增展品类别" v-model="showModal" class-name="vertical-center-modal" width="500px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="130" @submit.native.prevent>
            <FormItem label="展品类别：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="英文展品类别：" prop="nameEn">
              <Input v-model="formInline.nameEn" />
            </FormItem>
            <FormItem label="排序：" prop="showIndex">
              <InputNumber :max="99999999" :min="-10" v-model="formInline.showIndex"></InputNumber>
            </FormItem> 
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "classify-add",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      showModal: false,
      time: [],
      formInline: {
        // form双向绑定
        name: "",
        nameEn: "",
        showIndex: 0,
      },
      color: "#000",
      ruleInline: {
        name: [{ required: true, message: "展品类别不能为空", trigger: "blur" }],
        nameEn: [{ required: true, message: "英文展品类别不能为空", trigger: "blur" }],
      }
    };

  },
  computed: {
    ...mapGetters({
      hostExhibition: "hostSetModule/getHostExhibition",
    }),
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  methods: {
    ...mapActions({
      addCategory: "categoryModule/addCategory"
    }),
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        AgentId: "cd4e8cef-c6f7-4e72-9132-93161b9e8c43",
        groupId: this.hostExhibition.groupId,
        level: -1,
        loadChild: true,
        Name: form.name,
        NameEn: form.nameEn,
        ShowIndex: form.showIndex
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.addCategory(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

